(() => {
  const control = document.querySelector('[data-noir-night-mode]');
  if (!control) return;

  const root = document.documentElement;
  const toggle = control.querySelector('[data-noir-night-mode-toggle]');
  const label = control.querySelector('[data-noir-night-mode-label]');
  const storageKey = 'noir-night-mode';
  const legacyStorageKey = 'noir-keyboard-night-mode';
  const collectionRoot = document.querySelector(
    '[data-collection-root][data-collection-handle="mechanical-keyboards"]'
  );
  const nightImageSelector = '[data-noir-night-image]';
  const pendingImageLoads = new WeakMap();

  const rememberLightImage = (image) => {
    if (!image.dataset.noirLightSrc) {
      image.dataset.noirLightSrc = image.getAttribute('src') || '';
      image.dataset.noirLightSrcset = image.getAttribute('srcset') || '';
    }
  };

  const restoreLightImage = (image) => {
    rememberLightImage(image);
    pendingImageLoads.delete(image);

    if (image.dataset.noirLightSrc) {
      image.setAttribute('src', image.dataset.noirLightSrc);
    }

    if (image.dataset.noirLightSrcset) {
      image.setAttribute('srcset', image.dataset.noirLightSrcset);
    } else {
      image.removeAttribute('srcset');
    }
  };

  const swapToNightImage = (image) => {
    rememberLightImage(image);

    const nightImage = image.dataset.noirNightImage;
    if (!nightImage || image.getAttribute('src') === nightImage) return;

    const request = {};
    pendingImageLoads.set(image, request);

    const preload = new Image();
    preload.decoding = 'async';
    preload.onload = () => {
      if (pendingImageLoads.get(image) !== request || !root.classList.contains('noir-night-mode')) {
        return;
      }

      image.setAttribute('src', nightImage);
      image.removeAttribute('srcset');
      pendingImageLoads.delete(image);
    };
    preload.onerror = () => {
      if (pendingImageLoads.get(image) === request) {
        pendingImageLoads.delete(image);
      }
    };
    preload.src = nightImage;
  };

  const syncNightImages = (enabled) => {
    if (!collectionRoot) return;

    collectionRoot.querySelectorAll(nightImageSelector).forEach((image) => {
      if (enabled) {
        swapToNightImage(image);
      } else {
        restoreLightImage(image);
      }
    });
  };

  if (!toggle || !label) return;

  let storedValue = '';
  try {
    storedValue = window.localStorage.getItem(storageKey) || window.localStorage.getItem(legacyStorageKey) || '';
  } catch (error) {
    storedValue = '';
  }

  const setMode = (enabled, persist) => {
    root.classList.toggle('noir-night-mode', enabled);
    toggle.setAttribute('aria-pressed', String(enabled));
    toggle.setAttribute('aria-label', enabled ? 'Switch to light mode' : 'Enable night mode');
    label.textContent = enabled ? 'Day mode' : 'Night mode';
    syncNightImages(enabled);

    if (!persist) return;

    try {
      window.localStorage.setItem(storageKey, enabled ? 'on' : 'off');
    } catch (error) {
      return;
    }
  };

  setMode(storedValue === 'on', false);
  toggle.addEventListener('click', () => {
    setMode(!root.classList.contains('noir-night-mode'), true);
  });

  if (collectionRoot && typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => {
      if (root.classList.contains('noir-night-mode')) {
        syncNightImages(true);
      }
    });

    observer.observe(collectionRoot, { childList: true, subtree: true });
  }
})();
